import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { colors } from '../../../constants/colors';

export const StyledContainerButtonWithRedirect = styled.div`
  margin: 10px 0;
`;

export const StyledAnchor = styled(Link)`
  color: black;
  width: 100%;
  text-decoration: none;

  &&:hover {
    color: ${colors.black};
  }
`;

export const StyledIcon = styled.span`
  svg {
    font-size: 2rem;
    color: ${colors.strongGray};
    &:hover {
      svg {
        transition: all 0.3s;
        font-size: 2rem;
        color: ${colors.black};
      }
    }
  }
`;
